import { useEffect, useRef } from 'react';

interface TimerSoundProps {
  play: boolean;
}

export function TimerSound({ play }: TimerSoundProps) {
  const audioRef = useRef<HTMLAudioElement>(null);

  useEffect(() => {
    if (play && audioRef.current) {
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {
        // Ignore autoplay errors
      });
    }
  }, [play]);

  return (
    <audio
      ref={audioRef}
      src="https://assets.mixkit.co/active_storage/sfx/2869/2869-preview.mp3"
      preload="auto"
    />
  );
}